import { combineReducers } from 'redux';
import RoutePage from './SEOContainer/RoutePage/redux/reducer';
import BusCommonSEO from './SEOContainer/Common/redux/reducers';
import OperatorPage from './SEOContainer/OperatorPage/redux/reducer';
import CityPage from './SEOContainer/CityPage/redux/reducer';
import DirectoryPage from './SEOContainer/DirectoryPage/redux/reducer';
import CategoryPage from './SEOContainer/CategoryPage/redux/reducer';
import StandPage from './SEOContainer/StandPage/redux/reducer';

const reducerList = {
  routePage: RoutePage,
  BusCommonSEO: BusCommonSEO,
  operatorPage: OperatorPage,
  cityPage: CityPage,
  DirectoryPage: DirectoryPage,
  CategoryPage: CategoryPage,
  StandPage: StandPage,
};

export default reducerList;

const rootReducer = combineReducers(reducerList);

export type AppState = ReturnType<typeof rootReducer>;
